import React, { useState, useEffect } from 'react';
import httpos from "../../../helpers/httpos";
import WeatherDataPagination from './weatherDataPagination';
import { ToastContainer } from 'react-toastify';

export default function WeatherData({ weatherData, fetchWeatherData, isWeatherLoading, canAccessWeather = true }) {
  console.log(weatherData,weatherData?.length, 'weatherData in WeatherData component');
 useEffect(() => {
    if (!canAccessWeather) return;
    if (!weatherData || weatherData?.length === 0) {
      fetchWeatherData();
    }
  }, [canAccessWeather, fetchWeatherData, weatherData]);

  return (
    <div className="weatherInfoBlk relative">
      <ToastContainer />
      {!canAccessWeather ? (
        <div className='no_data_found alert alert-danger' style={{ padding: 30 }}>
          <h4>Upgrade required</h4>
          <p>
            Weather data is not available on your current plan. Please
            upgrade your plan to access this feature.
          </p>
          <div className="mt-3" style={{ display: "flex", justifyContent: "center" }}>
            <button
              type="button"
              className="site_btn"
              onClick={() => (window.location.href = "/pricing")}
            >
              Upgrade Plan
            </button>
          </div>
        </div>
      ) : null}
      {
        weatherData?.status===0 ?
        <div className='no_data_found alert alert-danger'>
          <h4>No Weather Data Found</h4>
          <p>{weatherData?.msg ? weatherData?.msg : ''}</p>
        </div>
        : ""
      }
      {canAccessWeather && isWeatherLoading ? (
        <div className='loading_container'>
          <h4>Please wait...!</h4>
          <div className="loadingio-spinner-eclipse-spin">
            <div className="load-spinner">
              <div></div>
            </div>
          </div>
        </div>
      ) : canAccessWeather ? (
        <>
          <div className="dhi-summary">
            <div className='flex justify-between items-center mb-2'>
                <h6 className="font-bold text-lg">Hail Intensity Summary</h6>
            </div>
            
            <div className='weatherLeft'>
              <p className='mb-0'>Hail Intensity Scale: <strong>1-10</strong> (10 = most severe)</p>
            </div>
            
            

            <hr />
          </div>

        {
          weatherData?.hail_data?.length <=0 && weatherData?.wind_data?.length ?
          <div className='no_data_found alert alert-danger'>
            <h4>No Weather Data Found</h4>
            <p>There is no weather data available for this property.</p>
          </div>
          :
          ""
        }
          {
            weatherData?.hail_data?.length > 0 ?
            <WeatherDataPagination
              data={weatherData?.hail_data || []}
              columns={[
                { header: 'Event Date', accessor: 'date' },
                { header: 'Station', accessor: 'station' },
                { header: 'Hail Size (in)', accessor: 'hail_size' },
                { header: 'Hail Intensity at Location', accessor: 'dhi_at_point' },
                // { header: 'Hail Intensity Indexes', accessor: 'dhi_at_point_indexes' },
                { header: 'Hail Intensity within 2 Mi', accessor: 'max_dhi' },
                // { header: 'Hail Frequency Index', accessor: 'freq_index' },
                { header: 'Storm Duration (min)', accessor: 'duration' },
                { header: 'Storm Heading', accessor: 'heading' },
                { header: 'Storm Speed (mph)', accessor: 'speed' },
              ]}
              title={"Hail Data"}
            />
            :
            ""
}
{
  weatherData?.wind_data?.length > 0 ?

            <WeatherDataPagination
                data={weatherData?.wind_data || []}
                columns={[
                  {
                    header: 'Date Time',
                    accessor: 'datetime',
                    render: (row) => new Date(row.datetime).toLocaleString('en-US'),
                  },
                  { header: 'Gust(MPH)', accessor: 'gust_mph' },
                ]}
                title={"Wind Data"}
                type="wind"
                rowsPerPage={15} // Adjust rows per page as needed
              />
              :
              ""
}
        </>
      ) : null}
    </div>
  );
}
